import { AUTH_BASE_URL } from "../../../constants";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  IUpdateProfileInfoRequestBody,
  IUpdateProfileInfoResponse,
} from "./models";

const appProvide = async () => AuthConfig.getAppToken();

export const updateProfileInfo = (
  id: string,
  body: IUpdateProfileInfoRequestBody
): Promise<IUpdateProfileInfoResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/profiles/${id}/personal`,
    "PATCH",
    appProvide
  );
  return fetchRequest(descriptor, body);
};
